import React from "react";
import { Card } from "primereact/card";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const LspSideBar = ({ id, activeTab }) => {
  return (
    <>
      <Card className="card-style h-full p-0">
        <div className="flex flex-column">
          <Link
            to={`/lsp/${id}/info`}
            className={`sidebar-align ${activeTab === "info" ? "active-entity" : "menu-hover"}`}
            // onClick={handleLinkClick}
          >
            <div className="flex align-items-center">
              <span className="pi pi-id-card icon-color"></span>
              <p className="sidebar-menu">General Information</p>
            </div>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
          <Link
            to={`/lsp/${id}/addresses`}
            className={`sidebar-align ${activeTab === "addresses" ? "active-entity" : "menu-hover"}`}
          >
            <div className="flex align-items-center">
              <span className="pi pi-users icon-color"></span>
              <p className="sidebar-menu">Trading Address</p>
            </div>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>

          <Link
            to={`/lsp/${id}/customer-portfolio`}
            className={`sidebar-align ${activeTab === "customer-portfolio" ? "active-entity" : "menu-hover"}`}
          >
            <div className="flex align-items-center">
              <span className="pi pi-cog icon-color"></span>
              <p className="sidebar-menu">Customer Portfolio</p>
            </div>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>

          <Link
            to={`/lsp/${id}/key-personnel`}
            className={`sidebar-align ${activeTab === "key-personnel" ? "active-entity" : "menu-hover"}`}
          >
            <div className="flex align-items-center">
              <span className="pi pi-cog icon-color"></span>
              <p className="sidebar-menu">Key Personnel</p>
            </div>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
        </div>
      </Card>
    </>
  );
};
LspSideBar.propTypes = {
  id: PropTypes.string,
  activeTab: PropTypes.bool,
};
export default LspSideBar;
